/**
 * Uygulamayı indirme düğmeleri — web kullanıcısını kendi telefonunun mağazasına götürür.
 *
 * iPhone/iPad → yalnız App Store, Android → yalnız Google Play; masaüstünde cihaz
 * bilinmediği için ikisi birden. Kurallar: StoreDownloadButtons.test.tsx.
 */
import { detectStoreForDevice, STORE_LINKS, type StoreKey } from '@/lib/billingPlatform'

const STORE_LABELS: Record<StoreKey, string> = {
  appStore: "App Store'dan indir",
  googlePlay: "Google Play'den indir",
}

const ALL_STORES: StoreKey[] = ['appStore', 'googlePlay']

type StoreDownloadButtonsProps = {
  /** Testte cihaz verilir; uygulamada tarayıcıdan okunur. */
  store?: StoreKey | null
  className?: string
}

export function StoreDownloadButtons({
  store = detectStoreForDevice(),
  className = '',
}: StoreDownloadButtonsProps) {
  const stores = store ? [store] : ALL_STORES

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {stores.map(key => (
        <a
          key={key}
          href={STORE_LINKS[key]}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 min-w-[140px] inline-flex items-center justify-center rounded-2xl bg-black px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-black/10 transition-colors hover:bg-gray-900 active:scale-95"
        >
          {STORE_LABELS[key]}
        </a>
      ))}
    </div>
  )
}

export default StoreDownloadButtons
